import experiences from './experiences'
export default {
    getExperiences: experiences.getExperiences,
    saveExperiences: experiences.saveExperiences
}